import { ReactNode } from 'react';
import clsx from 'clsx';

interface MainContentProps {
  children: ReactNode;
  className?: string;
}

export function MainContent({ children, className }: MainContentProps) {
  return (
    <main className={clsx('flex-1 overflow-auto bg-white', className)}>
      {children}
    </main>
  );
}
